import { Dot } from "lucide-react";

/**
 * Categorical priority badge for MUKTI 2.0 leads.
 * Replaces the numeric 0–100 risk score surface.
 *
 * Priority is one of: "high_attention" | "review" | "watch"
 */
const SPECS = {
  high_attention: {
    label: "HIGH ATTENTION",
    classes: "border-rose-500/60 bg-rose-50 text-rose-800",
    dot: "bg-rose-500 animate-pulse",
  },
  review: {
    label: "REVIEW",
    classes: "border-amber-500/60 bg-amber-50 text-amber-800",
    dot: "bg-amber-500",
  },
  watch: {
    label: "WATCH",
    classes: "border-slate-400/50 bg-slate-50 text-slate-700",
    dot: "bg-slate-400",
  },
};

export function PriorityBadge({ priority, size = "sm" }) {
  const spec = SPECS[priority] || SPECS.watch;
  const padding = size === "lg" ? "px-3 py-1 text-xs" : "px-2 py-0.5 text-[11px]";
  return (
    <span
      data-testid={`priority-badge-${priority}`}
      className={`inline-flex items-center gap-1 rounded-md border font-semibold tracking-wider uppercase ${padding} ${spec.classes}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${spec.dot}`} />
      {spec.label}
    </span>
  );
}
